import requestProvider from "./axiosHandler";

const getAllDepartment = () => {

    return requestProvider
        .get("/department/get-all")
};

const deleteDepartment = (id) => {

        return requestProvider
            .delete(`/department/${id}`)
};

const createDepartment = (list) => {

    return requestProvider
        .post('/department', {
            code: list.code,
            deleted: false,
            description: list.description,
            name: list.name
        })
};

const updateDepartment = (list) => {

    return requestProvider
        .put('/department', {
            code: list.code,
            description: list.description,
            name: list.name,
            id: list.id
        })
};

const getDepartmentById = (id) => {

    return requestProvider
        .get(`/department/${id}`)
};

const getDepartmentsWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/department?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllDepartment, deleteDepartment, createDepartment, updateDepartment, getDepartmentById, getDepartmentsWithPage}